import React from "react";
import SelectBox from "../../../../components/SelectBox";
import { canWorkerPerformService } from "../../helpers";

export default Worker = ({
  appointments,
  index,
  setCurrentIndex,
  setAppointments,
  workerLoading,
  filterSlots,
  getSlots,
  resetBookingApts,
  resetTimer,
  salon
}) => {

  const handleChange = (value) => {
    setCurrentIndex(index);
    const ids = appointments[index]?.data?.map((item) => {
      return item?.appointment?._id
    })
    if (ids?.length) {
      resetBookingApts({ ids, salonId: salon._id });
      resetTimer();
    }
    if (value === "any") {
      const currentServices = appointments[index]?.service || [];

      // Calculate skillWorkers for each service even in "Any Technician" mode
      const updatedServices = currentServices.map(service => {
        // Find all workers who CAN perform this service
        const capableWorkers = (appointments[index].workersResponse || []).filter(worker =>
          canWorkerPerformService(worker, service)
        );

        return {
          ...service,
          assignedWorker: null,
          skillWorkers: capableWorkers
        };
      });

      appointments[index] = {
        ...appointments[index],
        request: false,
        slot: null,
        worker: null,
        data: [],
        to: null,
        service: updatedServices || currentServices,
        workers: [
          { name: "Any Technician", value: "any" },
          { name: "Request Technician", value: "request" },
        ],
      };

    } else if (value === appointments[index]?.worker?.value) {
      appointments[index] = {
        ...appointments[index],
        slot: null,
        to: null,
        worker: null,
        request: false,
        data: [],
      };

    } else if (value === "request") {
      appointments[index] = {
        ...appointments[index],
        data: [],
        slot: null,
        to: null,
        workers: [
          { name: "Any Technician", value: "any" },
          ...appointments[index].workersResponse,
          { name: "Any", value: "any" },
        ],
      };

    } else {
      const selectedWorker = (appointments[index].workers || []).find(item => item.value === value);
      const currentServices = appointments[index]?.service || [];

      // Assign workers to each service based on capability
      const updatedServices = currentServices.map(service => {
        const canPerform = canWorkerPerformService(selectedWorker, service);
        // console.log("🚀 ~ handleChange ~ canPerform:", canPerform, service)

        // if (canPerform) {
        //   // Requested worker can do this service - assign to them
        //   return {
        //     ...service,
        //     assignedWorker: selectedWorker,
        //     skillWorkers: [...(service.skillWorkers || []), selectedWorker]
        //   };
        // } else {
          // Requested worker CANNOT do this service
          // Find all workers who CAN perform this service
          const capableWorkers = (appointments[index].workersResponse || []).filter(worker =>
            canWorkerPerformService(worker, service)
          );

          return {
            ...service,
            assignedWorker: null,
            skillWorkers: capableWorkers
          };
        // }
      });

      // Update current appointment
      appointments[index] = {
        ...appointments[index],
        worker: selectedWorker || {},
        service: updatedServices || currentServices,
        request: !!selectedWorker,
        slot: null,
        to: null,
        slots: filterSlots(appointments[index]?.totalSlots?.[selectedWorker?.value] || []),
      };
    }
    getSlots();

    setAppointments([...appointments]);
  };

  return (
    <div className="flex__col--12">
      <SelectBox
        placeholder="Select Technician"
        options={appointments[index].workers || []}
        defaultValue={appointments[index]?.workers?.[0] || "any"}
        isWorkerSelectBox
        onChange={handleChange}
        value={appointments[index]?.worker?.value || "any"}
        loading={workerLoading}
        error={appointments[index]?.error?.worker}
        notFoundContent="NO TECHNICIAN AVAILABLE"
      />
    </div>
  );
};
